import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"

import { GoTrash } from "react-icons/go";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import { useModal } from "../../../contexts/ModalContext";
import ModalNovoEmailNF from "./ModalNovoEmailNF";
import useApi from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import ConfirmDeleteEmailNF from "./ConfirmDeleteEmailNF";
import { useParams } from "react-router-dom";

const Header = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
`
const Titulo = styled.h2`
    margin: 0;
    font-size: 16px;
    color: #333;
`
const BotaoAdicionar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
        background-color: #1e40af;
    }
    transition: .2s all ease;
    padding: 10px 12px;
    box-sizing: border-box;
    margin-left: auto;
`
const Container = styled.div`
    width: 100%;
    max-height: 350px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    overflow-y: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    thead tr {
        background-color: #f0f0f0;
        height: 40px;
        th {
            padding: 0 15px;
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            color: #333;
        }
    }
    tbody tr {
        height: 40px;
        &:nth-child(even) {
            background-color: #fafafa;
        }
        &:nth-child(odd) {
            background-color: #fff;
        }
        td {
            padding: 0 15px;
            font-size: 11px;
            color: #333;
        }
        &:hover {
            background-color: #e0f7fa;
        }
    }
`
const ColunaAcoes = styled.td`
    width: 65px;
`
const IconesWrapper = styled.div`
    width: 65px;
`
const Lixeira = styled(GoTrash)`
    height: 20px;
    width: 20px;
    color: #e11d48;
    cursor: pointer;
    &:hover {
        color: #b91c1c;
    }
    transition: .2s all ease;
`

const ModalEmailsNF = () => {

    const { id } = useParams();
    const { isModalOpen, openModal, closeModal } = useModal();

    const api = useApi();

    const [loading, setLoading] = useState(false);

    const [emails, setEmails] = useState([]);
    const [pedido, setPedido] = useState(null);

    const fetchData = async () => {

        if( !id ) return;
        
        setLoading(true);

        try {

            const [ emailsRes, pedidoRes ] = await Promise.all([
                api.get(`/Painel/API/ControleMedicao/GetNFEmails/index.php?id=${id}`),
                api.get(`/Painel/API/ControleMedicao/GetPedido/index.php?id=${id}`)
            ])

            setEmails(emailsRes.data);
            setPedido(pedidoRes.data);

        } catch (e) {

            console.log(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchData();

    }, [id])

    const [selectedEmailId, setSelectedEmailId] = useState(null);

    const handleDeleteEmail = (id) => {

        setSelectedEmailId(id);
        openModal("modalDeleteEmailNF");

    }

    const handleCancelDeleteEmail = () => {

        setSelectedEmailId(null);
        closeModal();

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header size="lg" close={closeModal} >
                    <Header>
                        <Titulo>E-MAILS NOTA FISCAL | PC: { pedido?.num_pedido ?? "" } </Titulo>
                        <BotaoAdicionar onClick={() => openModal("modalAddEmailNF")}>ADICIONAR E-MAIL</BotaoAdicionar>
                    </Header>
                    <Container>
                        <Tabela>
                            <thead>
                                <tr>
                                    <th>USUÁRIO</th>
                                    <th>E-MAIL</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    loading ? (
                                        <tr>
                                            <td colSpan={3} style={{ textAlign: "center" }} >
                                                CARREGANDO...
                                            </td>
                                        </tr>
                                    ) : (
                                        emails.map((email) => (
                                            <tr key={email.id} >
                                                <td>{email.nome}</td>
                                                <td>{email.email}</td>
                                                <ColunaAcoes>
                                                    <IconesWrapper>
                                                        <Lixeira onClick={() => handleDeleteEmail(email.id)} />
                                                    </IconesWrapper>
                                                </ColunaAcoes>
                                            </tr>
                                        ))
                                    )
                                }
                            </tbody>
                        </Tabela>
                    </Container>
                </Modal>
            </Overlay>
            {
                isModalOpen("modalAddEmailNF") && (
                    <ModalNovoEmailNF
                        fetchData={fetchData}
                    />
                )
            }
            {
                isModalOpen("modalDeleteEmailNF") && (
                    <ConfirmDeleteEmailNF
                        id={selectedEmailId}
                        fecharModal={handleCancelDeleteEmail}
                        onDelete={ fetchData }
                    />
                )
            }
        </>
    )
}

export default ModalEmailsNF;
